<template>
  <!-- <div class="pay-title">成为会员</div> -->
  <div class="pay-page">
    <!-- 购买积分 -->
    <div class="section">
      <div class="section-header">
        <div class="section-title">选择积分</div>
        <div class="section-subtitle">支持商品链接咸🐟、tb、dy、168~</div>
      </div>
      <div class="options-scroll">
        <div class="options">
          <div
            v-for="item in pointsOptions"
            :key="item.id"
            class="option-card"
            :class="{ active: selectedType === 'points' && selectedId === item.id }"
            @click="selectPoints(item)"
          >
            <div class="option-title">{{ item.name }}</div>
            <div class="option-price">¥{{ item.price * 0.01}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 购买会员 -->
    <div class="section">
      <div class="section-header">
        <div class="section-title">选择会员</div>
        <div class="section-subtitle">不支持商品链接</div>
      </div>
      <div class="options-scroll">
        <div class="options">
          <div
            v-for="item in memberOptions"
            :key="item.id"
            class="option-card"
            :class="{ active: selectedType === 'member' && selectedId === item.id }"
            @click="selectMember(item)"
          >
            <div class="option-title">{{ item.name }}</div>
            <div class="option-price">¥{{ item.price * 0.01 }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 选中信息 -->
    <div class="summary-box" v-if="selectedItem">
      <div class="summary-content">
        您选择了：<strong>{{ selectedItem.name }}</strong>
        ，需支付 <span class="price">¥{{ selectedItem.price * 0.01 }}</span>
      </div>
      <div class="summary-content">
        <strong class="date">账号ID：SYF{{ String(userInfo.id).padStart(6,'0') }}</strong>
      </div>
      <div class="summary-content">
        <template v-if="selectedType === 'member'">
          到期时间：<span class="date">{{ deadlineTime}}</span>
        </template>
      </div>
    </div>

    <!-- 按钮区域 -->
    <div class="action-buttons" @click="handlePay">
      <van-button type="danger" round block >立即支付</van-button>
    </div>
  </div>
</template>

<script setup>
import { ref , onMounted} from 'vue'
import { showToast} from 'vant';
import { useRoute } from 'vue-router'
import { getUserInfo } from '@/api/user'
import { getVipGoodsList, commitVipOrder} from '@/api/vip'
import { formatTime } from '@/utils/date';
import { wechatMpPay } from '@/api/pay';
import { redirectToWeChatAuth } from '@/utils/wxauth'; 

document.title = "水印坊";
const route = useRoute()
let token = route.query.token
const code = route.query.code

// 使用ref创建响应式变量
const pointsOptions = ref([])
const memberOptions = ref([])
const userInfo = ref({})
const deadlineTime = ref('')
// 当前选中状态
const selectedType = ref('member') // 'points' | 'member'
const selectedId = ref('2')
// 选中项计算
const selectedItem = ref({})


onMounted(() => {

  console.log(token)
  if(token) {
    localStorage.setItem('token', token)
  } else {
    token = window.location.href.split('token=')[1]
  }
  
  if(code) {
    const goodsId = Number(route.query.state)
    console.log('goodsId: '+goodsId+', code: '+code)
    commitVipOrder(goodsId, code)
    .then(res=> {
      console.log(res)
      wechatMpPay(res)
    }).catch(err => {
      console.error(err)
    })
  }
  getVipGoodsList()
      .then(res=>{
        console.log(JSON.stringify(res))
        // 查询列表结果
        pointsOptions.value = res.times
        memberOptions.value = res.members
        console.log(memberOptions.value)
        selectedId.value = memberOptions.value[0].id
        selectedItem.value = memberOptions.value[0]
        getUserInfo()
          .then(res=>{
            userInfo.value = res
            console.log(JSON.stringify(userInfo.value))
            // 计算截止
            caculateDeadlineTime()
            
          })
          .catch(err=>{
            console.error(err)
          })
      })
      .catch(err=>{
        console.error(err)
      })


})

// 切换选择积分
const selectPoints = (item) => {
  console.log('selectPoints:'+JSON.stringify(item))
  selectedType.value = 'points'
  selectedId.value = item.id
  selectedItem.value = item
  caculateDeadlineTime()
}

// 切换选择会员
const selectMember = (item) => {
  console.log('selectMember:'+JSON.stringify(item))
  selectedType.value = 'member'
  selectedId.value = item.id
  selectedItem.value = item
  caculateDeadlineTime()
}

/**
 * 计算截止时间
 */
const caculateDeadlineTime = ()=> {
      const currentMis = new Date().getTime()
      const startTime = userInfo.value.deadlineTime < currentMis? currentMis:userInfo.value.deadlineTime
      deadlineTime.value = formatTime(new Date(startTime + (selectedItem.value.value * 24*60*60*1000)))
}

// 支付
const handlePay = () => {
  if (!selectedItem.value) return showToast('请选择套餐')
  
  showToast('正在发起支付...')
  redirectToWeChatAuth(selectedItem.value.id)
  
}

// 客服

</script>

<style scoped>
.pay-title {
  padding: 16px 0;
  font-size: 16px;
  font-weight: bold;
  background-color: white;
}
.pay-page {
  background: #f7f8fa;
  padding: 16px;
  min-height: 100vh;
  max-width: 600px;
  margin: 0 auto;
}

.section {
  margin-bottom: 24px;
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.section-header {
  margin-bottom: 12px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.section-subtitle {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.options-scroll {
  overflow-x: auto;
  padding-bottom: 8px;
  -webkit-overflow-scrolling: touch;
}

.options {
  display: inline-flex;
  gap: 12px;
  padding-right: 16px;
}

.option-card {
  flex: 0 0 auto;
  width: 60px;
  padding: 16px 12px;
  background: #fff;
  border-radius: 8px;
  text-align: center;
  border: 1px solid #ebedf0;
  transition: all 0.2s;
  cursor: pointer;
}

.option-card.active {
  border-color: #ff5500;
  background: #fff0f0;
  box-shadow: 0 2px 6px rgba(238, 10, 36, 0.1);
}

.option-title {
  font-size: 15px;
  margin-bottom: 8px;
  font-weight: 500;
}

.option-price {
  color: #ee0a24;
  font-size: 16px;
  font-weight: 450;
}

.summary-box {
  background: #fff;
  padding: 16px;
  border-radius: 12px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.summary-content {
  font-size: 14px;
  line-height: 1.6;
}

.price {
  color: #ff5500;
  font-weight: bold;
}

.date {
  color: #333;
}

.action-buttons {
  background-color: #ff5500;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 450;
  color: white;
  padding: 15px;
}

.contact {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  font-size: 14px;
  color: #1989fa;
  cursor: pointer;
}

.contact span {
  margin-left: 4px;
}

/* 隐藏滚动条但保留滚动功能 */
.options-scroll::-webkit-scrollbar {
  display: none;
}
</style>